export default __webpack_public_path__ + "static/low-fi-dark-5c7d8b571dc413dc53b802853a2ac6952e1e9899d38d5e7092f07d465ad545d0.png";